import { CHANGE_DATA_NAV } from '_reducers/nav'


export const changeDataNav = data => {
  return {
    type: CHANGE_DATA_NAV,
    data,
  }
}
